import React, { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import $ from 'jquery'

import "../styles/filterbox.scss";
import api from '../utils/api';
import handleNoOp from '../utils/handleNoOp';
import { useAtom } from 'jotai';
import { useResetAtom } from "jotai/utils"
import atoms from '../utils/atoms';

const useCheckboxes = (options, values = [], onChange = () => {}) => {
    const [selected, setSelected] = useState({})
    const selectedValues = useMemo(() => Object.entries(selected).filter(([, value]) => value).map(([key, ]) => key), [selected])

    useEffect(() => {
        if (selectedValues.length !== values.length) {
            setSelected({})
        }
    }, [selectedValues, values])

    const set = useCallback((key, value) => {
        const newValues = {
            ...selected,
            [key]: value
        }
        setSelected(newValues)
        onChange?.(Object.entries(newValues).filter(([, value]) => value).map(([key, ]) => key))
    }, [setSelected, selected])

   

    return [selected, set]
}

const Durations = ({ options, values, onChange = () => {}, setTab }) => {

    const [selected, set] = useCheckboxes(options, values, onChange)


    return (
        <>
            {
                options.map(option => (
                    <div key={option.key} className="checkbox">
                        <label>
                            <input tabIndex={setTab} name="duration" checked={selected[option.key] ?? false} data-ref={option.key} type="checkbox" value={option.key} id={option.key}
                                onChange={(e) => {
                                    set(option.key, e.target.checked)
                                }}
                            /> {option.value}
                        </label>
                    </div>
                ))
            }
        </>
    )
}

const Tags = ({ options, values, onChange = () => {}, setTab }) => {

    const [selected, set] = useCheckboxes(options, values, onChange)

    return (
        <>
             {
                 options.map(option => (
                     <li key={option.key}>
                         <div className="checkbox">
                             <label>
                                 <input tabIndex={setTab} name="tags" type="checkbox" checked={selected[option.key] ?? false} value={option.key} id={option.key}
                                     onChange={(e) => {
                                         set(option.key, e.target.checked)
                                     }}
                                 /> {option.value} <span className="d-none">({option.numberOfTimesUsed})</span> </label>
                         </div>
                     </li>
                 ))
             }
         </>
    )
}

const useFetch = url => {
    const [data, setData] = useState([])

    useEffect(() => {
        api.get(url)
            .then(resp => resp.data)
            .then(setData)
    }, [url])

    return data
}


function FilterBox(props) {

    const [form, setForm] = useAtom(atoms.form)
    const resetForm = useResetAtom(atoms.form)

    useEffect(() => {
        setTimeout(changeCounter, 0)
    }, [form, resetForm])

    const tags = useFetch("/tags/")
    const duration = useFetch("/durationTypes/")
    const startDateTypes = useFetch("/startDateTypes/")

    const [setActive, setActiveState] = useState("");
    const [setHeight, setHeightState] = useState("0px");
    const [setMargin, setMarginState] = useState("0px");
    const [setIcon, setIconState] = useState("fa-angle-down");
    const [setHidden, setHiddenState] = useState(false);
    const [setTab, setTabState] = useState("-1");

    const content = useRef(null);

    function toggleAccordion() {
        setActiveState(setActive === "" ? "active" : "");
        setHeightState(setActive === "active" ? "0px" : `${content.current.scrollHeight}px`);
        setMarginState(setActive === "active" ? "" : `mt-4`);
        setIconState(setActive === "active" ? "fa-angle-down" : 'fa-angle-down');
        setHiddenState(setActive === "active" ? false : true);
        setTabState(setActive === "active" ? "-1" : "0");
    }

    function changeCounter() {
        // TODO change badgecounter logic from jquery to react
        let badgeCounter = 0;
        badgeCounter += $('#filterForm input[type="checkbox"]:checked').length
        if ($('#startDateTypes').length && $('#startDateTypes').val() !== 'any') { badgeCounter++ }
        $('#filterBadge').text(badgeCounter);
        if (badgeCounter > 0) { $('#filterBadge, a.link').removeClass('d-none'); } else { $('#filterBadge, a.link').addClass('d-none'); }
    }

    const handleDurationChange = values => setForm(f => { f.filters.duration = values })
    const handleEnrollmentChange = e => setForm(f => { f.filters.openEnrollment = e.target.checked })
    const handleTagsChange = values => setForm(f => { f.filters.tags = values })
    const handleStartDate = e => setForm(f => { f.filters.starts = e.target.value } )

    const handleReset = () => {
        resetForm()
        changeCounter()
    }

    return (
        <span className="accordion-section">
            <button className={`btn btn-secondary float-right ${setActive}`} onClick={toggleAccordion} aria-expanded={setHidden} aria-controls="filter-box"
                style={{ borderRadius: "4px" }}>
                <span className="accordion-title">{props.title}</span>
                <i className={`fas ml-2 ${setIcon}`} />
                <span id="filterBadge" className="badge badge-secondary d-none">0</span>
            </button>
            <a role="button" className={`float-right link d-none mt-1 mr-2`} onClick={handleReset} style={{ borderRadius: "4px" }}>Clear Filters</a>
            <div id="filter-box" ref={content} style={{ maxHeight: `${setHeight}` }} className={`filter-box ${setMargin}`} tabIndex={setTab}>
                <div className="bg-gray border border-dark pt-4 px-4">
                    <form onSubmit={handleNoOp} className="d-flex flex-row" id="filterForm" aria-controls="course-results">
                        <input className="d-none" type="reset" onClick={handleReset} value="Reset" />
                        <div className="mr-5" style={{ width: "200px" }}>
                            <div className="checkbox mt-0">
                                <fieldset className="fieldset no-border mb-4 pb-0">
                                    <legend>Enrollment</legend>
                                    <div className="checkbox">
                                        <label>
                                            <input tabIndex={setTab} checked={form.filters.openEnrollment} onChange={handleEnrollmentChange} type="checkbox" /> Open for Enrollment
                                        </label>
                                    </div>
                                </fieldset>
                            </div>
                            {startDateTypes.length ?
                                <div className="mb-4">
                                    <label className="d-block mr-1" htmlFor="startDateTypes">Start Date</label>
                                    <select className="form-control" tabIndex={setTab} name="startDateTypes" id="startDateTypes" value={form.filters.starts} onChange={handleStartDate} style={{ background: "white", display: "inline-block", width: "auto", }}>
                                        {startDateTypes.map(startDateTypes => (
                                            <option value={startDateTypes.key} key={startDateTypes.key}>{startDateTypes.value}</option>
                                        ))}
                                    </select>
                                    
                                </div>
                                : null}
                        </div>
                        <div className="mr-5 mb-3" style={{ width: "100px" }}>
                            {duration.length ?
                                <fieldset className="fieldset no-border mb-0 pb-0">
                                    <legend>Duration</legend>
                                    <Durations
                                        options={duration}
                                        values={form.filters.duration}
                                        setTab={setTab}
                                        onChange={handleDurationChange}
                                    />
                                </fieldset>
                                : null}
                        </div>
                        <div>
                            {tags.length ?
                                <fieldset className="fieldset no-border">
                                    <legend>Course Tags</legend>
                                    <ul className="list-inline">
                                        <Tags
                                            options={tags}
                                            values={form.filters.tags}
                                            setTab={setTab}
                                            onChange={handleTagsChange}
                                        />
                                    </ul>
                                </fieldset>
                                : null}
                        </div>
                    </form>
                </div>
            </div>
        </span >
    );
}
export default FilterBox;